module.exports = __webpack_public_path__ + "static/media/clients.6669f8b2.svg";